import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import type { IHttpApiResponse } from '@tarslib/types/lib/httpApiResponse';
import { Tooltip } from 'aui';
import clsx from 'clsx';
import React from 'react';

export type CollapseHeaderProps = {
  value: IHttpApiResponse;
};

export function CollapseHeader(props: CollapseHeaderProps) {
  const { value } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  const codeCategory = React.useMemo(() => {
    const result = parseInt(String(value.code / 100));
    if (Number.isNaN(result)) {
      return 0;
    }

    return result;
  }, [value.code]);

  const icon = React.useMemo(() => {
    switch (codeCategory) {
      case 2:
        return '🟢';
      case 3:
        return '🔵';
      case 4:
        return '🟠';
      case 5:
        return '🔴';
      default:
        return '⚪';
    }
  }, [codeCategory]);

  return (
    <div className="flex gap-2 text-paragraph font-400 leading-lg">
      <Tooltip title={clientI18n('http.status.code.tooltip')}>
        <span>
          <span className="mr-2">{icon}</span>
          <span
            className={clsx({
              ['text-green-6']: codeCategory === 2,
              ['text-blue-6']: codeCategory === 3,
              ['text-gold-6']: codeCategory === 4,
              ['text-red-6']: codeCategory === 5,
              ['text-color']: codeCategory < 2 || codeCategory > 5,
            })}
          >
            {value.code}
          </span>
        </span>
      </Tooltip>

      <span className="font-400 text-color">{value.name}</span>
    </div>
  );
}
